import React from "react";

interface ItemListSearchInputProps {
    activeSearchKeyword: string;
    onSearchSubmit: (keyword: string) => void;
}

export const ItemListSearchInput: React.FC<ItemListSearchInputProps> = ({
    activeSearchKeyword,
    onSearchSubmit,
}) => {
    const [searchKeyword, setSearchKeyword] = React.useState<string>(activeSearchKeyword);

    React.useEffect(() => {
        setSearchKeyword(activeSearchKeyword);
    }, [activeSearchKeyword]);

    return (
        <div className="row align-items-center">
            {/* 아이템 검색 */}
            <div className="col pe-1">
                <input
                    type="text"
                    name="search-keyword"
                    className="form-control item-list-search-input"
                    placeholder="상품명/상점 상품코드 검색"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSearchSubmit(searchKeyword);
                        }
                    }}
                />
            </div>
            <div className="col-auto ps-0 ms-0 d-flex align-items-center">
                <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => onSearchSubmit(searchKeyword)}
                >
                    검색
                </button>
            </div>
        </div>
    );
};

export default ItemListSearchInput;
